import React from 'react';
import { Button, ButtonGroup, Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { StockRestrictions } from '../../../../global/entities/BuyOrder';
import { Form } from '../../../form';
import { FormSectionInfo } from '../../../form/components';
import { RHFRadioGroup } from '../../../../packages/react-hook-form/radio-group/radio-group';
import { RadioLabelled } from '../../../../packages/radio-labelled';
import { RadioConvertUtils } from '../../../../utils/radio/radio';
import { FormSectionContainer } from '../../../form/components/form-section-container/form-section-container';
import { BuyProcessFormUserTip } from '../user-tip/user-tip';
import { BuyProcessFormNextButton } from '../buy-process-form-next-button/buy-process-form-next-button';
import { BuyProcessFormAdminSubmitButton } from '../buy-process-form-admin-submit-button/buy-process-form-admin-submit-button';
import { useReservation } from './use-reservation';
import {
  RightFirstRefusalLabel,
  StockRestrictionLabel,
} from './reservation-utils';

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(5),
  },
}));

export const BuyProcessFormReservation = () => {
  const { formMethods, onSubmit, onBack, onForward, isUpdating } = useReservation();
  const classes = useStyles();

  return (
    <Form onSubmit={onSubmit}>
      <BuyProcessFormUserTip>
        <div>
          <FormSectionInfo.InfoBoxTitled title="Olika typer av förbehåll" />
          <Typography>
            Det finns idag tre typer av förbehåll som man kan göra i
            bolagsordningen. Det är hembudsförbehåll, samtyckesförbehåll och
            förköpsförbehåll. Förbehåll i bolagsordningen är ett bra komplement
            till aktieägaravtal. Aktieägaravtal bör man ha om man är fler än en
            ägare i bolaget.
          </Typography>
        </div>
      </BuyProcessFormUserTip>

      <div>
        <FormSectionInfo.InfoBoxTitled title="Hembud">
          <Typography>
            Det vanligaste förbehållet är hembud. Vid ett hembudsförbehåll äger
            aktieägare rätt att köpa tillbaka aktier som hamnat i någon annans
            ägo.
          </Typography>
        </FormSectionInfo.InfoBoxTitled>

        <FormSectionContainer className={classes.section}>
          <RHFRadioGroup
            label="Hembud *"
            control={formMethods.control}
            name="rightFirstRefusal"
            defaultValue={RadioConvertUtils.true}
          >
            <RadioLabelled
              value={RadioConvertUtils.true}
              label={RightFirstRefusalLabel.true}
            />
            <RadioLabelled
              value={RadioConvertUtils.false}
              label={RightFirstRefusalLabel.false}
            />
          </RHFRadioGroup>
        </FormSectionContainer>
      </div>

      <div>
        <FormSectionInfo.InfoBoxTitled title="Förköps- eller Samtyckesförbehåll">
          <Typography>
            Förköp innebär att befintliga aktieägare ska erbjudas köpa aktier i
            bolaget innan de bjuds ut till nya aktieägare. Samtycke innebär att
            överlåtelse av aktier till nya aktieägare får endast ske med
            bolagets samtycke. Dessa kan inte kombineras med varandra.
          </Typography>
        </FormSectionInfo.InfoBoxTitled>

        <FormSectionContainer>
          <RHFRadioGroup
            label="Önskas Förköps- eller Samtyckesförbehåll? *"
            control={formMethods.control}
            name="stockRestrictions"
            defaultValue={String(StockRestrictions.None)}
          >
            <RadioLabelled
              value={String(StockRestrictions.RightFirstOffer)}
              label={StockRestrictionLabel[StockRestrictions.RightFirstOffer]}
            />
            <RadioLabelled
              value={String(StockRestrictions.Consent)}
              label={StockRestrictionLabel[StockRestrictions.Consent]}
            />
            <RadioLabelled
              value={String(StockRestrictions.None)}
              label={StockRestrictionLabel[StockRestrictions.None]}
            />
          </RHFRadioGroup>
        </FormSectionContainer>
      </div>

      <ButtonGroup>
        <Button onClick={onBack}>Tillbaka</Button>
        <BuyProcessFormNextButton onClick={onForward}>
          Nästa
        </BuyProcessFormNextButton>
        <BuyProcessFormAdminSubmitButton loading={isUpdating}>
          Spara
        </BuyProcessFormAdminSubmitButton>
      </ButtonGroup>
    </Form>
  );
};
